import autoComplete from 'javascript-autocomplete'

class DrForm {
	constructor(drForm) {
		this.$formShell = jQuery(drForm);
		this.$formLoader = this.$formShell.find('.dr-loader');
		this.$formWrapper = this.$formShell.find('.wFormWrapper');
		this.$formEl = this.$formShell.find('form');
		this.$company = this.$formEl.find('.calc-company');
		this.$submit = this.$formEl.find('.primaryAction');
		this.customizeForm();
		this.showForm();
	}

	customizeForm() {
		// Add class to apply styles on checkboxes error messages correctly
		this.$formEl.find('.inputWrapper input[type="checkbox"]').each((index, el) => {
            if (el) {
                el.closest('.oneField').classList.add("checkboxField");
            }
		});
		this.customizeLabels();
		this.updateSubmitBtnText();
		this.initCompanyAutocomplete();
		this.handleSelects();
        this.applyCustomPrivacyText();
	}

	customizeLabels() {
		let fieldSelector = '.inputWrapper input, .inputWrapper select, .inputWrapper textarea';
		this.$formEl.on("focus", fieldSelector, (e) => {
			this.onInputFocus(e);
		});
		this.$formEl.on("blur", fieldSelector, (e) => {
			this.onInputBlur(e);
		});
		this.$formEl.on("keyup change input", fieldSelector, (e) => {
			this.onInputChange(e);
		});
		document.addEventListener('wFORMSLoaded', (e) => {
			// For some reason this.$formEl doesn't work
			this.$formShell.find(fieldSelector).each((index, el) => {
				this.onInputChange(el);
			});
		});
        // For some reason this.$formEl doesn't work
        this.$formShell.find(fieldSelector).each((index, el) => {
            this.onInputChange(el);
        });
	}

	updateSubmitBtnText() {
		let btnCustomText = this.$formShell.data('button-text');
		let openFormMobileBtn = jQuery('.js-open-form-mobile-btn');
		if (btnCustomText) {
			// Update desktop button, mobile button already has custom text
			this.$submit.val(btnCustomText);
		}
		if (!openFormMobileBtn.data('btn-updated')) {
			if (!btnCustomText) {
				// Desktop button is ok, sync mobile button text with desktop button
				openFormMobileBtn.text(this.$submit.val());
			}
			// Show button for mobile form opening on mobile
			openFormMobileBtn.addClass('uk-hidden@m');
			openFormMobileBtn.removeClass('uk-hidden');
			openFormMobileBtn.data('btn-updated', 1);
		}
	}

	initCompanyAutocomplete() {
		// Company field autocomplete. Not applied for school-field
		new autoComplete({
			selector: this.$company.get(0),
			minChars: 1,
			offsetTop: 4,
			delay: 100,
			source: (term, response) => {
				jQuery.getJSON('https://autocomplete.clearbit.com/v1/companies/suggest', {query: term}, (data) => {
					response(data);
				});
			},
			renderItem: (item, search) => {
				let default_logo = 'https://s3.amazonaws.com/clearbit-blog/images/company_autocomplete_api/unknown.gif';
				let logo = default_logo;
				if (item.hasOwnProperty('logo') && item.logo !== null) {
					logo = item.logo + '?size=30x30';
				}

				return '<div class="autocomplete-suggestion" data-name="' + item.name +
					'" ' +
					'data-domain="' + item.domain + '" ' +
					'data-val="' + search +
					'"><span class="icon"><img align="center" src="' + logo + '" ' +
					'onerror="this.src=\'' + default_logo + '\'"></span>' + item.name +
					'<span class="domain">' + item.domain + '</span></div>';
			},
			onSelect: (e, term, item) => {
				let $item = jQuery(item);
				this.$company.val($item.data('name'));
				this.$formEl.get(0).closest('.dr-form').dataset['companywebsite'] = $item.data('domain');
			},
		});
	}

	handleSelects() {
		this.$formEl.find('select').each(function (index, select) {
			select.querySelectorAll('option').forEach(function (option) {
				if (option.value) {
					option.dataset['value'] = option.innerText.trim();
				}
			});
		});
	}

    applyCustomPrivacyText() {
        let privacyHolder = this.$formWrapper.find('.custom-privacy-text')
        if(privacyHolder.length){
            this.$formEl.find('.form-privacy-text').html(privacyHolder.html());
        }

	}

	showForm() {
		// Place dr-loader before submit button
		this.$formLoader.hide();
		this.$submit.before(this.$formLoader.detach());
		// Show form
		this.$formWrapper.removeAttr("style");
	}

	// Processing of form labels
	getCurrentInput(e) {
		return e instanceof HTMLElement ? e : e.currentTarget;
	}

	getCurrentInputWrap(e) {
		return this.getCurrentInput(e).closest('.oneField');
	}

	onInputFocus(e) {
		this.getCurrentInputWrap(e).classList.add("is-focused");
	}

	onInputBlur(e) {
		this.getCurrentInputWrap(e).classList.remove("is-focused");
		this.onInputChange(e);
	}

	onInputChange(e) {
		const currentInput = this.getCurrentInput(e);
		const currentInputWrap = this.getCurrentInputWrap(e);
		if (currentInputWrap) {
			if (currentInput.value) {
				currentInputWrap.classList.add("not-empty");
			} else {
				currentInputWrap.classList.remove("not-empty");
			}
		}
	}
}

export default DrForm;
